<tt-field-group 
    v-bind="{ id, describedbyId, label, required }" :errorText="error" :hintText="hint">
    <textarea class="tt-o-textarea" 
              ref="field"
              :class="{'tt-o-textarea__success': success, 'tt-o-textarea--active': focusOnMount}"
              @input="updateValue"
              @focus="focusTextarea"
              @blur="blurTextarea"
              :aria-describedby="describedbyId"
              :aria-required="required ? 'true' : 'false'"
              :aria-invalid="errorText ? 'true' : 'false'"
              v-bind="{ id, name, rows, disabled, value}"
    ></textarea>
</tt-field-group>



// WEBPACK FOOTER //
// ./src/objects/form/textarea.html